import React, { CSSProperties } from 'react';
import { colorsModeUI, MODE_UI_OPTIONS } from '../../../../modeUI';
import './LineLabels.css';

interface IVAxes {
  ticks: number[];
  label: string;
  textPosition: 'none';
}
interface LineLabelsProps {
  vAxes: Record<number, IVAxes>;
  mode: MODE_UI_OPTIONS;
  width: CSSProperties['width'];
}
export const LineLabels = (props: LineLabelsProps) => {
  let { vAxes = {}, mode, width } = props;
  const modeColors = colorsModeUI(mode);
  const styleLine: CSSProperties = {
    borderColor: modeColors.INFORMATION_COLOR,
  };
  // support empty case
  if (Array.isArray(vAxes)) vAxes = {};
  return (
    <div className="LineLabels" style={{ minWidth: width, maxWidth: width }}>
      {Object.values(vAxes).map((item) => {
        const styleContainer = { ...styleLine };
        // show center if only has one element
        if (item.ticks.length === 1) styleContainer.justifyContent = 'center';
        return (
          <div
            key={item.label}
            className="LineLabels__Container"
            style={styleContainer}
          >
            <span className="LineLabels__Header" title={item.label}>{item.label}</span>
            {item.ticks.map((value, index) => (
              <LineLabelItem
                key={`${value}`}
                value={value}
                styleLine={styleLine}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

interface LineLabelItemProps {
  value: number;
  styleLine?: CSSProperties;
}
const LineLabelItem = ({ value, styleLine }: LineLabelItemProps) => {
  return (
    <div className="LineLabels__Item">
      {value}
      <span className="LineLabels__Item-line" style={styleLine}></span>
    </div>
  );
};
